// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"f0354c42","446":"3b34b1dc","488":"b0c7e77a","495":"19453432"}[chunkId] + ".chunk.js";
};